import Vue from 'vue';
import App from './App.vue';
import InstantSearch from 'vue-instantsearch';
import * as VueGoogleMaps from 'vue2-google-maps';
import GmapCluster from 'vue2-google-maps/dist/components/cluster';
import algoliasearch from 'algoliasearch';

Vue.use(InstantSearch);

Vue.use(VueGoogleMaps, {
    load: {
        // your Google API key
        key: 'AIzaSyCxYdICoJ6YMhxn9rXDQafn6BVBRDjsfJU',
        libraries: 'places'
    },
    installComponents: true
});

Vue.component('GmapCluster', GmapCluster);

const node = document.querySelector('#geosearch');

if (node) {
    const client = algoliasearch(window.algoliaId, window.algoliaSearchKey);
    const index = client.initIndex(node.dataset.index);

    new Vue({
        el: '#geosearch',

        data: {
            ...node.dataset,
            hits: [],
            windowWidth: window.innerWidth
        },

        computed: {
            isMobile() {
                return this.windowWidth <= 768;
            }
        },

        created() {
            index.browseObjects({
                query: '',
                batch: (batch) => {
                    this.hits = this.hits.concat(batch);
                }
            });

            window.addEventListener('resize', () => {
                this.windowWidth = window.innerWidth;
            });
        },

        render: (h) => h(App)
    });
}
